import { z } from 'zod';

export const fontSchema = z.object({
  image: z.string().regex(/^\/media\/fonts\/.*?\.png$/),
  names: z.array(z.string()),
  position: z.number().min(1),
  active: z.boolean(),
  capabilities: z.array(
    z.enum([
      'DTF',
      'Digital',
      'Sublimation',
      'CupPrint',
      'Flock',
      'Flex',
      'color',
      'efx'
    ])
  ),
  key: z.number().min(1),
  allowed: z.array(z.number().min(1)).optional()
});
